import { BudgetCapping } from '../../../../__generated__/graphql'

type BudgetMeasuresSpent = {
  monthSpent?: number | null
  periodSpent?: number | null
  overallSpent?: number | null
}

export const getSpentForBudgetCappingType = (
  budgetCappingType: BudgetCapping,
  budgetMeasures: BudgetMeasuresSpent | null | undefined
): number => {
  switch (budgetCappingType) {
    case BudgetCapping.Monthly:
      return budgetMeasures?.monthSpent ?? 0
    case BudgetCapping.Period:
      return budgetMeasures?.periodSpent ?? 0
    case BudgetCapping.Overall:
      return budgetMeasures?.overallSpent ?? 0
    default:
      return 0
  }
}

export const spentLabelKeyForBudgetCappingType = (budgetCappingType: BudgetCapping): string => {
  switch (budgetCappingType) {
    case BudgetCapping.Monthly:
      return 'adgroup.spentBudget.monthSpent'
    case BudgetCapping.Period:
      return 'adgroup.spentBudget.periodSpent'
    case BudgetCapping.Overall:
      return 'adgroup.spentBudget.overallSpent'
    default:
      return 'adgroup.spentBudget.overallSpent'
  }
}

export const getOverallLeftToSpend = (budgetCapping: number, spent: number): number => budgetCapping - spent

export const getOverallBudgetAfterDelta = (currentBudgetCapping: number, delta: number): number =>
  currentBudgetCapping + delta

export type OverallBudgetBounds = {
  min: number
  max: number
}

export const isOverallBudgetWithinBounds = (budgetCapping: number, bounds: OverallBudgetBounds): boolean =>
  budgetCapping >= bounds.min && budgetCapping <= bounds.max

export const canApplyOverallBudgetDelta = (
  currentBudgetCapping: number,
  delta: number,
  bounds: OverallBudgetBounds
): boolean => {
  if (delta === 0 || Number.isNaN(delta)) return false
  const next = getOverallBudgetAfterDelta(currentBudgetCapping, delta)
  return isOverallBudgetWithinBounds(next, bounds)
}
